import script from "./ParentChildren.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentChildren.vue?vue&type=script&setup=true&lang=js"

import "./ParentChildren.vue?vue&type=style&index=0&id=ca2cae00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca2cae00"]])

export default __exports__